<template lang="pug">
  .grid.bordered-bottom.top-space.contact-information
    div.grid-children
      div.block.is-marginless
        p.type-thin {{ gettext('Contact information') }}
      div.block
        p.type {{ gettext('Contact person') }}
    div.grid-children.wide.v-center
      p {{ gettext('Joachim Veckmann') }}
    div.grid-children
      div.block
      div.block
        p.type {{ gettext('Phone') }}
    div.grid-children.wide.v-center
      p {{ gettext('+38 (093) 556 55-55') }}
    div.grid-children
      div.block
      div.block
        p.type {{ gettext('Email') }}
    div.grid-children.wide.v-center
      p {{ gettext('andrey-ivanov@gmail.com') }}
</template>
<script>
import { gettext } from '@/services/TranslateHandler'

export default {
  name: 'OfferContacts',
  methods: {
    gettext: gettext
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/vacancy/parts/offer/parts/contacts/index.vue